import { useLocation } from 'react-router';
import { NETWORKS } from '@/constants';

export default function useNetwork(): string | undefined {
  const location = useLocation();
  const pathSegments = location.pathname.split('/');

  let network = undefined;
  if (pathSegments.length >= 2) {
    const networkSegment = pathSegments[1];
    if (NETWORKS.includes(networkSegment)) {
      network = networkSegment;
    }
  }
  return network;
}
